import { makeStyles, Theme } from '@material-ui/core';

export const useQueueStyles = makeStyles<Theme>((theme) => ({
  simpleTrQueue: {
    margin: '0',
  },
  conflictTrQueue: {
    background: 'var(--color-error-3)',
    borderRadius: 0,
    margin: '0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '& $wrapper': {
      marginLeft: '0',
    },
    '& $wrapperActive:hover': {
      background: 'rgba(255, 255, 255, 0.02)',
    },
    '& $txWrapper:last-child $wrapper': {
      borderBottom: 'none !important',
    },
    [theme.breakpoints.down('md')]: {
      margin: '0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0',
      '& $wrapper': {
        marginLeft: '0px',
      },
    },
  },
  alertConflictTrQueue: {
    background: 'var(--color-error-10)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px 8px 32px',
    gap: '8px',
    borderRadius: '0px 8px 0px 0px',
    margin: '0',
    alignSelf: 'start',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 16px',
    },
  },
  alertNonConflictTrQueue: {
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#949494',
    padding: '8px 8px 16px',
    margin: '0 32px',
  },
  queueNonceLabel: {
    margin: '16px 24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '0 8px',
      fontSize: '12px',
      fontWeight: 400,
      padding: '8px',
    },
  },
  nonconflictTrQueue: {
    padding: '0 16px',
  },
  wrapper: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: `29% 16% 16% 10% 13% 16%`,
    justifyItems: 'start',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '20px',
    padding: '16px 32px',
    borderBottom: '0.5px solid var(--color-black-4)',
    background: 'rgba(255, 255, 255, 0)',
    transition: 'all ease 0.2s',
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateRows: 'repeat(2, 1fr)',
      gridTemplateColumns: '7% 50% 15% 28%',
      gridGap: '4px',
      fontSize: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      // display: 'grid',
      // gridTemplateRows: 'repeat(2, 1fr)',
      // gridTemplateColumns: '8% 50% 42%',
      // gridGap: '3px',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '2px',
      fontSize: '10px',
      padding: '8px 16px',
      justifyContent: 'space-between',
    },
    '& > div:nth-child(1)': {
      [theme.breakpoints.down('sm')]: {
        gridRow: '1/-1',
        gridColumn: '1/2',
      },
    },
    '& > div:nth-child(2)': {
      [theme.breakpoints.down('sm')]: {
        gridRow: '1/-1',
        gridColumn: '2/3',
        // display: "none",
      },
    },
    '& > div:nth-child(3)': {
      [theme.breakpoints.down('sm')]: {
        // display: 'none',
      },
    },
    '& > div:nth-child(4)': {
      [theme.breakpoints.down('sm')]: {
        gridRow: '1/2',
        gridColumn: '3/4',
        textAlign: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    '& > div:nth-child(5)': {
      [theme.breakpoints.down('sm')]: {
        justifySelf: 'center',
        gridRow: '1/2',
        gridColumn: '4/4',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    '& > div:nth-child(6)': {
      [theme.breakpoints.down('sm')]: {
        gridRow: '2/2',
        gridColumn: '4/4',
        justifySelf: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        // gridColumn: '3/3',
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        width: '100%',
        gap: 8,
        // paddingRight: '8px',
      },
    },
  },
  wrapperActive: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.035)',
    },
  },
  wrapperDisabled: {
    background: '#1E1E1F',
    '&& *': {
      color: 'rgba(171, 171, 171, 1)',
    },
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1)',
    },
  },
  txWrapper: {
    overflow: 'hidden',
    display: 'grid',
    padding: '0',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0',
    },

    '&:last-child $wrapper': {
      // borderBottom: 'none',
    },
  },
  buttonsWrapper: {
    justifySelf: 'flex-end',
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    [theme.breakpoints.down('xs')]: {
      paddingRight: '0px',
    },
  },
  typeContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  txType: {
    width: '100%',
  },
  txLink: {
    alignSelf: 'flex-start',
    marginTop: 0,
  },
  button: {
    '&&': {
      borderRadius: '6px',
      background: 'rgba(255, 255, 255, 0.10)',
      color: '#F6F8FA',
      height: 48,
      minWidth: 84,
      zIndex: 5,
      display: 'flex',
      justifyContent: 'center',

      '& svg': {
        marginRight: 0,
      },

      '&:hover': {
        color: '#F6F8FA',
        background: 'rgba(255, 255, 255, 0.08)',
      },
      [theme.breakpoints.down('sm')]: {
        height: 46,
        minWidth: 80,
      },
      [theme.breakpoints.down('sm')]: {
        height: 36,
        minWidth: 60,
        fontSize: 12,
      },
    },
  },
  buttonActive: {
    '&&': {
      background: '#7F53FE',

      '&:hover': {
        background: '#8e63ff',
      },
    },
    '&:disabled': {
      background: 'rgba(255, 255, 255, 0.10)',
    },
  },
  link: {
    color: '#BBA4FF',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  buttonRejectActive: {
    '&&': {
      background: '#FFFFFF0D',
      color: '#F6F8FA',
      opacity: 0.3,
    },
  },
}));
